import BuisnessHero from "@/Components/BusinessLanding/BuisnessHero";
import GoodToGrabFAQ from "@/Components/BusinessLanding/SmartlyFAQ";
import SmartlyOrderPromo from "@/Components/BusinessLanding/SmartlyOrderPromo";
import Footer from "@/Components/Landing/Footer";
import Navbar from "@/Components/Landing/Navbar";
import Choosing from "@/Components/Landing/WhyChoosing";

const Buisness = () => {
  return (
    <>
      <Navbar />
      <BuisnessHero />
      <Choosing />
      <SmartlyOrderPromo />
      <GoodToGrabFAQ />
      <Footer />
    </>
  );
};

export default Buisness;
